module.exports = __webpack_public_path__ + "static/media/18ECA1.2c027302.jpg";